import React, {useCallback, useMemo, useState} from "react";
import "./index.scss";
import {connect} from "react-redux";
import {object, oneOf} from "prop-types";
import Title from "features/components/title";
import {Icon} from "features/components/icon";
import {__} from "services/i18n";
import moment, {ISO_8601} from "moment";
import {HOURS_TO_CONSIDER_NEW} from "constants.js";
import {favoriteVideoErrorSelector} from "store/reducer/video/favorite/selectors";
import {favoriteVideoStart} from "store/reducer/video/favorite/reducer";
import {withToastManager} from "react-toast-notifications";
import {historyObject} from "historyObject";
import defaultImage from "images/logo/marchio.svg";
/* istanbul ignore next */
const mapStateToProps = state => ({
    error: favoriteVideoErrorSelector(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    favoriteVideoStart
};
export const VideoCard = (props) => {
    const {video, type, error, favoriteVideoStart} = props;

    const [favorite, setFavorite] = useState(video.favorite);

    const toggleFavorite = useCallback((event) => {
        setFavorite(!favorite);
        favoriteVideoStart({id: video.id, favorite: !favorite});
        event.preventDefault();
        event.stopPropagation();
    }, [favorite, video, favoriteVideoStart]);

    React.useEffect(() => {
        setFavorite(video.favorite);
    }, [video]);

    const {toastManager} = props;
    React.useEffect(() => {
        if(!error.inError) return;
        toastManager.add(__(error.error), { appearance: 'error', id: 'favorite-video-fail' })
    }, [error, toastManager]);

    const isNew = useMemo(() => {
        return moment().diff(moment(video.created_at, ISO_8601), 'hours') < HOURS_TO_CONSIDER_NEW;
    }, [video]);

    const navigateToDetail = useCallback(() => {
        historyObject.push(`/video/${video.id}`);
    }, [video.id]);

    const renderTypeFlag = useMemo(() => {
        if(video.type === "normal") return null;
        return <div className={"flag_type"}><Title size={14}>{__(`common.video-type.${video.type}`)}</Title></div>
    }, [video]);

    return <div className={`video-card ${type || "light"}`} onClick={navigateToDetail}>
        <div className={"image"}>
            <img src={video.image || defaultImage} alt={"video preview"}/>
            <div className="backdrop" />
            <div className="favorite-btn" onClick={toggleFavorite}>
                <Icon>{favorite ? "heart-fill": "heart"}</Icon>
            </div>
            <div className="flags">
                {video.requires_payment && <div className="paid">
                    <Icon>lock</Icon>
                    <Title size={14}>€ {video.cost}</Title>
                </div>}
                {isNew && <div className="new">
                    <Title size={14}>{__("common.new")}</Title>
                </div>}
            </div>
            {renderTypeFlag}
        </div>
        <div className={"category"}>
            <Title size={12}>{video.categories[0]}</Title>
        </div>
        <Title size={20}>{video.title}</Title>
    </div>
};

VideoCard.propTypes = {
    type: oneOf(["dark", "light"]),
    video: object.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(withToastManager(VideoCard));